import { Auth0Provider, AppState, User } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { environmentConfig } from '../../environment-config';
import { insureiqPages } from '@harvestiq/constants';
import { useRedirect } from '../Redirect/index';

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const { redirectOrNavigate } = useRedirect();

  const {
    domain,
    clientId,
    useRefreshTokens,
    authorizationParams: { audience },
  } = environmentConfig.auth0;

  if (!domain || !clientId) {
    throw new Error(
      'Auth0 domain and clientId must be provided in the environment config'
    );
  }

  const redirectUri = `${window.location.origin}${insureiqPages.authCallback.path}`;

  /**
   * @param appState set from the caller of `loginWithRedirect`
   * @param user the Authenticated user object returned from Auth0
   */
  const onRedirectCallback = (appState?: AppState, user?: User) => {
    // Send the user back to the page configured when calling `loginWithRedirect` or the the home page
    const targetUrl = appState?.returnTo ?? insureiqPages.home.path;

    // Remove the code and state parameters coming from Auth0 in the URL by replacing
    // Redirect the user if there is a redirect path
    redirectOrNavigate(targetUrl, {
      replace: true,
    });
  };

  return (
    <Auth0Provider
      cacheLocation="localstorage"
      domain={domain}
      clientId={clientId}
      useRefreshTokens={useRefreshTokens}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
